import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Box,
  FormHelperText,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import { useState } from "react";

interface PasswordInputProps {
  value: string;
  onChange: (value: string) => void;
}

export default function PasswordInput({ value, onChange }: PasswordInputProps) {
  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPassword = () => setShowPassword((prev) => !prev);

  const errors: string[] = [];

  return (
    <Box>
      <TextField
        type={showPassword ? "text" : "password"}
        label="Contraseña"
        fullWidth
        value={value}
        onChange={(e) => onChange(e.target.value)}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={toggleShowPassword} edge="end">
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
        error={errors.length > 0}
      />

      {errors.length > 0 && (
        <FormHelperText error>
          {errors.map((e, idx) => (
            <div key={idx}>{e}</div>
          ))}
        </FormHelperText>
      )}
    </Box>
  );
}
